import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { mapMutations, mapState } from "vuex";
import OverlayWrapper from "./OverlayWrapper";
import ServeModal from "./ServeModal";
import DetailModal from "./DetailModal";
import bus from "vue3-eventbus";
export default {
  name: "ListJoinItem",
  components: {
    OverlayWrapper: OverlayWrapper,
    ServeModal: ServeModal,
    DetailModal: DetailModal
  },
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      show: false,
      showService: false,
      showDetail: false
    };
  },
  computed: {
    statusText: function statusText() {
      return ["已删除", "未审核", "进行中", "不通过"][this.item.status - 0 + 1];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(["setUid", "setTotalIngral", "setAppInfo", "setIsSelected", "setType", "setActiveIndex"])), {}, {
    showDetailModal: function showDetailModal() {
      this.showDetail = true;
    },
    onClickList: function onClickList(item) {
      console.log(item);

      var _id = item.id ? item.id : 1;

      this.$router.push({
        path: "/detail/" + _id
      });
    },
    updateActiveIndex: function updateActiveIndex() {
      console.log(1);
      this.setActiveIndex(1);
    },
    hiddenOverlay: function hiddenOverlay() {
      this.show = false;
      console.log("busoff");
      bus.off("overlayClose");
    },
    updateAddress: function updateAddress() {
      this.show = true;
      console.log("buslisten");
      bus.on("overlayClose", this.hiddenOverlay);
    }
  }),
  mounted: function mounted() {//this.item.applicationStatus = "3";
  }
};